export const PLACEMENT_TYPES: PlacementType[] = [
  "bottom-start",
  "bottom-end",
  "bottom-center",
  "top-start",
  "top-center",
  "top-end",
  "left-end",
  "left-center",
  "left-start",
  "right-end",
  "right-center",
  "right-start",
  "center"
];

export type PlacementType =
  | "bottom-start"
  | "bottom-end"
  | "bottom-center"
  | "top-start"
  | "top-center"
  | "top-end"
  | "left-end"
  | "left-center"
  | "left-start"
  | "right-end"
  | "right-center"
  | "right-start"
  | "center";
